import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {DigitalSignClauses} from '../../../../digital-sign/models/digital-sign-clauses';
import {DossierType, SignersType} from '@shared/components/core-sign/models/enums.model';
import {DigitalSignSimpleClauseModel} from '@shared/components/core-sign/models/digital-signer.model';

@Injectable({
	providedIn: 'root'
})

export class DigitalSignEventsService {
	get goDirectlyTiDigitalSign(): Subject<void> {
		return this._goDirectlyTiDigitalSign;
	}

	get canGoToNextStepSubject(): Subject<boolean> {
		return this._canGoToNextStepSubject;
	}

	get nextStepOperatorSubject(): Subject<boolean> {
		return this._nextStepOperatorSubject;
	}

	get contentDialogDialogResponseSubject(): Subject<{ simpleClauses: DigitalSignSimpleClauseModel[], index: number }> {
		return this._contentDialogDialogResponseSubject;
	}

	get openContentElementDialogSubject(): Subject<ContentElementDialogModel> {
		return this._openContentElementDialogSubject;
	}

	get procedureGoToNextStepSubject(): Subject<boolean> {
		return this._procedureGoToNextStepSubject;
	}

	get getLoadedInfocertDocumentSubject(): Subject<{document: string, index: number}> {
		return this._getLoadedInfocertDocumentSubject;
	}

	get loadInforcertDocumentSubject(): Subject<{ urlFile: any; token: string, index: number }> {
		return this._loadInforcertDocumentSubject;
	}

	get openOperatorOtpDialogSubject(): Subject<{ documents_singed: DigitalSignClauses[] }> {
		return this._openOperatorOtpDialogSubject;
	}

	get abortOperatorProcedureSubject(): Subject<void> {
		return this._abortOperatorProcedureSubject;
	}

	get nextStepCustomerSubject(): Subject<{ value: boolean; body: DigitalSignClauses }> {
		return this._nextStepCustomerSubject;
	}

	get openCustomerOtpDialogSubject(): Subject<{ documents_singed: DigitalSignClauses[] }> {
		return this._openCustomerOtpDialogSubject;
	}

	get abortCustomerProcedureSubject(): Subject<void> {
		return this._abortCustomerProcedureSubject;
	}

	get createDossierForSignerSubject(): Subject<{ sign_type: SignersType, dossier_type: DossierType, body?: DigitalSignClauses }> {
		return this._createDossierForSignerSubject;
	}

	get getCreatedDossierForSignerSubject(): Subject<{ signer_type: SignersType, dossier_type: DossierType, dossier: any, token?: string }> {
		return this._getCreatedDossierForSignerSubject;
	}

	get downloadInforcertDocumentSubject(): Subject<{ mUrl: string; token: string, name: string }> {
		return this._downloadInforcertDocumentSubject;
	}

	openOperatorOtpDialogObservable: Observable<{ documents_singed: DigitalSignClauses[] }>;
	protected _openOperatorOtpDialogSubject: Subject<{ documents_singed: DigitalSignClauses[] }>;

	nextStepOperatorObservable: Observable<boolean>;
	protected _nextStepOperatorSubject: Subject<boolean>;

	abortOperatorProcedureObservable: Observable<void>;
	protected _abortOperatorProcedureSubject: Subject<void>;

	nextStepCustomerObservable: Observable<{ value: boolean, body: DigitalSignClauses }>;
	protected _nextStepCustomerSubject: Subject<{ value: boolean, body: DigitalSignClauses }>;

	openCustomerOtpDialogObservable: Observable<{ documents_singed: DigitalSignClauses[] }>;
	protected _openCustomerOtpDialogSubject: Subject<{ documents_singed: DigitalSignClauses[] }>;

	abortCustomerProcedureObservable: Observable<void>;
	protected _abortCustomerProcedureSubject: Subject<void>;

	createDossierForSignerObservable: Observable<{ sign_type: SignersType, dossier_type: DossierType, body?: DigitalSignClauses }>;
	protected _createDossierForSignerSubject: Subject<{ sign_type: SignersType, dossier_type: DossierType, body?: DigitalSignClauses }>;

	getCreatedDossierForSignerObservable: Observable<{ signer_type: SignersType, dossier_type: DossierType, dossier: any, token?: string }>;
	protected _getCreatedDossierForSignerSubject: Subject<{ signer_type: SignersType, dossier_type: DossierType, dossier: any, token?: string }>;

	downloadInfocertDocumentObservable: Observable<{ mUrl: string, token: string, name: string }>;
	protected _downloadInforcertDocumentSubject: Subject<{ mUrl: string, token: string, name: string }>;

	loadInfocertDocumentObservable: Observable<{ urlFile: any; token: string, index: number }>;
	protected _loadInforcertDocumentSubject: Subject<{ urlFile: any; token: string, index: number }>;

	getLoadedInfocertDocumentObservable: Observable<{document: string, index: number}>;
	protected _getLoadedInfocertDocumentSubject: Subject<{document: string, index: number}>;

	procedureGoToNextStepObservable: Observable<boolean>;
	protected _procedureGoToNextStepSubject: Subject<boolean>;

	openContentElementDialogObservable: Observable<ContentElementDialogModel>;
	protected _openContentElementDialogSubject: Subject<ContentElementDialogModel>;

	contentDialogResponseObservable: Observable<{ simpleClauses: DigitalSignSimpleClauseModel[], index: number }>;
	protected _contentDialogDialogResponseSubject: Subject<{ simpleClauses: DigitalSignSimpleClauseModel[], index: number }>;

	canGoToNextStepObservable: Observable<boolean>;
	protected _canGoToNextStepSubject: Subject<boolean>;

	goDirectlyToDigitalSign: Observable<void>;
	protected _goDirectlyTiDigitalSign: Subject<void>;

	constructor() {
		this._abortOperatorProcedureSubject = new Subject<void>();
		this.abortOperatorProcedureObservable = this._abortOperatorProcedureSubject.asObservable();

		this._openOperatorOtpDialogSubject = new Subject<{ documents_singed: DigitalSignClauses[] }>();
		this.openOperatorOtpDialogObservable = this._openOperatorOtpDialogSubject.asObservable();

		this._nextStepOperatorSubject = new Subject<boolean>();
		this.nextStepOperatorObservable = this._nextStepOperatorSubject.asObservable();

		this._abortCustomerProcedureSubject = new Subject<void>();
		this.abortCustomerProcedureObservable = this._abortCustomerProcedureSubject.asObservable();

		this._nextStepCustomerSubject = new Subject<{ value: boolean, body: DigitalSignClauses }>();
		this.nextStepCustomerObservable = this._nextStepCustomerSubject.asObservable();

		this._openCustomerOtpDialogSubject = new Subject<{ documents_singed: DigitalSignClauses[] }>();
		this.openCustomerOtpDialogObservable = this._openCustomerOtpDialogSubject.asObservable();

		this._createDossierForSignerSubject = new Subject<{ sign_type: SignersType, dossier_type: DossierType, body?: DigitalSignClauses }>();
		this.createDossierForSignerObservable = this._createDossierForSignerSubject.asObservable();

		this._getCreatedDossierForSignerSubject = new Subject<{ signer_type: SignersType, dossier_type: DossierType, dossier: any, token: string }>();
		this.getCreatedDossierForSignerObservable = this._getCreatedDossierForSignerSubject.asObservable();

		this._downloadInforcertDocumentSubject = new Subject<{ mUrl: string, token: string, name: string }>();
		this.downloadInfocertDocumentObservable = this._downloadInforcertDocumentSubject.asObservable();

		this._loadInforcertDocumentSubject = new Subject<{ urlFile: any; token: string, index: number }>();
		this.loadInfocertDocumentObservable = this._loadInforcertDocumentSubject.asObservable();

		this._getLoadedInfocertDocumentSubject = new Subject<{document: string, index: number}>();
		this.getLoadedInfocertDocumentObservable = this._getLoadedInfocertDocumentSubject.asObservable();

		this._procedureGoToNextStepSubject = new Subject<boolean>();
		this.procedureGoToNextStepObservable = this._procedureGoToNextStepSubject.asObservable();

		this._openContentElementDialogSubject = new Subject<ContentElementDialogModel>();
		this.openContentElementDialogObservable = this._openContentElementDialogSubject.asObservable();

		this._contentDialogDialogResponseSubject = new Subject<{ simpleClauses: DigitalSignSimpleClauseModel[], index: number }>();
		this.contentDialogResponseObservable = this._contentDialogDialogResponseSubject.asObservable();

		this._canGoToNextStepSubject = new Subject<boolean>();
		this.canGoToNextStepObservable = this._canGoToNextStepSubject.asObservable();

		this._goDirectlyTiDigitalSign = new Subject<void>();
		this.goDirectlyToDigitalSign = this._goDirectlyTiDigitalSign.asObservable();
	}
}


export interface ContentElementDialogModel {
	index: number;
	y: number;
	dialogTitle: string;
	url: string;
	actionsAlignment: string;
	simpleClauses: DigitalSignSimpleClauseModel[];
	token: string;
	signer_type: SignersType;
}
